import { ActionTypes as Type } from '../actions/trash';
import {
  getEnableTags,
  getFlatTags,
  validationSearchParams,
} from '../lib/tools';
import * as types from '../lib/constants';

const appInitialState = {
  trashInfo: {
    timelines: [],
    pagenation: {
      totalNumber: 0,
      totalPages: 0,
      currentPage: 1,
    },
    searchOptions: {
      numberPerPage: 100,
      page: 1,
      sortColumns: [
        {
          column: 'recordedDate',
          order: 'D',
        },
      ],
      recordedDateFrom: '',
      recordedDateTo: '',
      partialOperatorName: '',
      partialDeviceNickname: '',
      tags: {
        depth: null,
        tagId: null,
      },
      isSearchForUnsetTagOnly: false,
      isInvalidDataOnly: true,
      freeTag: '',
    },
    searchOptionsError: {
      recordedDateFrom: false,
      recordedDateTo: false,
    },
    selectOptions: {
      maxDepth: 5,
      tags: {},
      ids: {},
    },
    checkbox: {
      ids: [],
    },
    selectedTagIds: [],
    executeEvent: '',
    previous: '/ds/timeline',
  },
  trashMediaInfo: {
    info: {
      analysis: {
        analyzingStatus: '0',
        content: '',
        status: '',
      },
      id: null,
      existsPrevData: false,
      existsNextData: false,
      tags: [],
      freeTag: '',
      groups: [],
    },
    mediaFullScreenMode: types.MEDIA_FULLSCREEN_MODE.windowed,
    mediaMapFullScreenMode: types.MEDIA_MAP_FULLSCREEN_MODE.windowed,
    analysisResult: '',
    isOpenMore: false,
    isOpenAnalysis: false,
    searchPosition: types.MEDIA_SEARCH_POSITION.current,
    searchOptions: {},
    previous: '/trash',
  },
  flatTags: [],
  tagsForSearch: [],
};

export default (state = appInitialState, action) => {
  switch (action.type) {
    /* trash action */
    case 'COMPANY_CHANGED': {
      return { ...appInitialState };
    }
    case Type.OPEN_TRASH: {
      const trashInfo = {
        ...state.trashInfo,
        previous: appInitialState.trashInfo.previous,
      };
      return { ...state, trashInfo };
    }
    case Type.INIT_TRASH_INFO: {
      const { previous } = state.trashInfo;
      if (previous !== appInitialState.trashInfo.previous) {
        // 最近削除した項目詳細画面から遷移時は初期化せずにstateを返却
        return { ...state };
      }
      return { ...state, trashInfo: appInitialState.trashInfo };
    }
    case Type.UPDATE_SEARCH_OPTIONS: {
      // 検索条件を更新
      const { option: params } = action;
      const optionError = validationSearchParams(params);
      const searchOptions = {
        ...state.trashInfo.searchOptions,
        ...params,
        page: 1,
      };
      const searchOptionsError = {
        ...state.searchOptionsError,
        ...optionError,
      };
      const key = Object.keys(params)[0];
      // 更新した検索条件がtags以外の場合はそのままsearchOptionをstateに反映する
      if (key !== 'tags') {
        return {
          ...state,
          trashInfo: { ...state.trashInfo, searchOptions, searchOptionsError },
        };
      }
      // 階層タグ選択状況を更新
      const { depth, tagId } = params.tags;
      const { selectedTagIds, selectOptions } = state.trashInfo;
      // 選択階層含めて上位階層を一度初期化する
      for (let i = depth; i <= selectOptions.maxDepth; i += 1) {
        delete selectedTagIds[i - 1];
      }
      let { tags } = searchOptions;
      if (tagId !== -1) {
        selectedTagIds[depth - 1] = tagId;
      } else {
        // 未設定状態が選択された場合、選択階層より一つ下の階層を検索条件に設定し直す
        tags = {
          depth: depth === 1 ? null : depth - 1,
          tagId: depth === 1 ? null : selectedTagIds[depth - 2],
        };
      }
      const trashInfo = {
        ...state.trashInfo,
        searchOptions: { ...searchOptions, tags },
        searchOptionsError,
        selectedTagIds,
      };
      return { ...state, trashInfo };
    }
    case Type.CLICK_UNSET_TAG_ONLY_CHECKBOX: {
      const trashInfo = {
        ...state.trashInfo,
        searchOptions: {
          ...state.trashInfo.searchOptions,
          isSearchForUnsetTagOnly: action.checked,
        },
      };
      return { ...state, trashInfo };
    }
    case Type.CLICK_LIST_CHECKBOX: {
      const checkedHeader = action.value === 'all';
      const targetIds = checkedHeader
        ? state.trashInfo.timelines.map(timeline => timeline.id)
        : [Number(action.value)];
      const ids = action.checked
        ? state.trashInfo.checkbox.ids
            .concat(targetIds)
            .filter((x, i, self) => self.indexOf(x) === i)
        : state.trashInfo.checkbox.ids.filter(x => targetIds.indexOf(x) === -1);
      return { ...state, trashInfo: { ...state.trashInfo, checkbox: { ids } } };
    }
    case Type.UPDATE_EXECUTE_EVENT: {
      return {
        ...state,
        trashInfo: {
          ...state.trashInfo,
          executeEvent: action && action.executeEvent,
        },
      };
    }
    case Type.PAGENATION_SELECT_PAGE: {
      const page =
        (action && action.page) || appInitialState.trashInfo.searchOptions.page;
      const trashInfo = {
        ...state.trashInfo,
        searchOptions: { ...state.trashInfo.searchOptions, page },
      };
      return { ...state, trashInfo };
    }
    case Type.SUCCESS_API_GET_WORK_RECORDS: {
      const { timelines, totalNumber, totalPages } = action.payload;
      const pagenation = {
        ...state.trashInfo.pagenation,
        totalNumber,
        totalPages,
      };
      const trashInfo = { ...state.trashInfo, timelines, pagenation };
      return { ...state, trashInfo };
    }
    case Type.SUCCESS_API_GET_TAGS: {
      const resultTags = action.payload.tags;
      const tags = {};
      resultTags.forEach((value, index) => {
        tags[index + 1] = value.data;
      });
      const trashInfo = {
        ...state.trashInfo,
        selectOptions: { ...state.trashInfo.selectOptions, tags },
      };
      return { ...state, trashInfo };
    }
    case Type.SUCCESS_API_ENABLE_WORK_RECORDS:
    case Type.SUCCESS_API_DELETE_WORK_RECORDS: {
      return {
        ...state,
        trashInfo: {
          ...state.trashInfo,
          checkbox: appInitialState.trashInfo.checkbox,
          searchOptions: {
            ...state.trashInfo.searchOptions,
            page: appInitialState.trashInfo.searchOptions.page,
          },
        },
      };
    }
    /* trash media action */
    case Type.OPEN_TRASH_MEDIA: {
      const trashInfo = {
        ...state.trashInfo,
        previous: '/trash/media/*',
      };
      const searchOptions = {
        ...state.trashInfo.searchOptions,
        searchPosition: appInitialState.trashMediaInfo.searchPosition,
      };
      const trashMediaInfo = { ...state.trashMediaInfo, searchOptions };
      return { ...state, trashInfo, trashMediaInfo };
    }
    case Type.INIT_TRASH_MEDIA_INFO: {
      return { ...state, trashMediaInfo: appInitialState.trashMediaInfo };
    }
    case Type.TOGGLE_MORE: {
      return {
        ...state,
        trashMediaInfo: {
          ...state.trashMediaInfo,
          isOpenMore: !state.trashMediaInfo.isOpenMore,
        },
      };
    }
    case Type.TOGGLE_MEDIA_MAP: {
      const { mediaMapFullScreenMode: current } = state.trashMediaInfo;
      const mediaMapFullScreenMode =
        current === types.MEDIA_MAP_FULLSCREEN_MODE.windowed
          ? types.MEDIA_MAP_FULLSCREEN_MODE.fullscreen
          : types.MEDIA_MAP_FULLSCREEN_MODE.windowed;
      return {
        ...state,
        trashMediaInfo: { ...state.trashMediaInfo, mediaMapFullScreenMode },
      };
    }
    case Type.TOGGLE_MEDIA_FULLSCREEN: {
      const mediaFullScreenMode =
        state.trashMediaInfo.mediaFullScreenMode ===
        types.MEDIA_FULLSCREEN_MODE.windowed
          ? types.MEDIA_FULLSCREEN_MODE.fullscreen
          : types.MEDIA_FULLSCREEN_MODE.windowed;
      return {
        ...state,
        trashMediaInfo: { ...state.trashMediaInfo, mediaFullScreenMode },
      };
    }
    case Type.SUCCESS_API_GET_WORK_RECORD: {
      return {
        ...state,
        trashMediaInfo: { ...state.trashMediaInfo, info: action.payload || {} },
      };
    }
    /** タグ検索によるタイムライン絞り込み処理 */
    case Type.SEARCHBOX_UPDATE_SEARCH_TAGS: {
      const { params } = action;
      const searchOptions = {
        ...state.trashInfo.searchOptions,
        tags: params[params.length - 1],
        page: 1,
      };
      const selectedTagIds = params.map(({ tagId }) => tagId);
      const tags = getEnableTags(state.tagsForSearch, params);
      const selectOptions = {
        maxDepth: 5,
        tags,
        ids: {}, // 未使用なので設定しない
      };
      const trashInfo = {
        ...state.trashInfo,
        searchOptions,
        selectedTagIds,
        checkbox: appInitialState.trashInfo.checkbox,
        selectOptions,
      };
      return {
        ...state,
        trashInfo,
        flatTags: appInitialState.flatTags,
        tagsForSearch: [],
      };
    }
    /** 全タグ情報取得後処理 */
    case Type.SUCCESS_API_GET_ALL_TAGS: {
      const tagsForSearch = action.payload.tags || [];
      const flatTags = getFlatTags(tagsForSearch);
      return { ...state, flatTags, tagsForSearch };
    }
    /** trash用タグ検索ダイアログクローズ処理 */
    case Type.CLOSE_TAG_SEARCH_DIALOG: {
      const { flatTags, tagsForSearch } = appInitialState;
      return { ...state, flatTags, tagsForSearch };
    }
    default:
      return state;
  }
};
